import { useEffect, useState } from "react";
import { AttachmentsDetailsError, NamesOfFieldEnum, OrgTypeEnum } from "~/typings/types";
import { DefaultPage, useAttachmentsDetails } from "~/pages/questionnaires/shared";
import {
  CompanyDetails,
  AccountDetails,
  PayformTechDetails,
  AdditionalDetails,
  AttachmentsDetails,
} from "./steps";
import { HELPER_FILE } from "~/pages/questionnaires/v1/customer/api/apiUrls";
import { V2Wizard } from "../../../shared/wizard";

const COUNT_UPLOAD_LOGO_FILE = 1;

export const CompanyStep = ({
  clientId,
  paymentMethod,
  educationalPlatform,
  queryPromocode,
  setOrgType,
  productType,
  ...sharedStepProps
}: any) => {
  const [textLinkAttachment, setTextLinkAttachment] = useState('');
  const [workType, setWorkType] = useState<"personal" | "joint">("personal");
  const isWorkWithThirdParties = workType === "joint";
  const [documentAgreement1FileIdRequiredError, setDocumentAgreement1FileIdRequiredError] = useState<AttachmentsDetailsError | null>(null);
  const [isFirstRenderPayformTechDetailsStep, setIsFirstRenderPayformTechDetailsStep] = useState(false);

  useEffect(() => {
    setOrgType(OrgTypeEnum.Company);
  }, []);

  const attachmentsDetails = useAttachmentsDetails({
    clientId,
    orgType: OrgTypeEnum.Company,
    initialLogoFileId: sharedStepProps.initialValues.logo_main_file_id,
    initialPassportFileId: sharedStepProps.initialValues.passport_file_id,
    initialPassportMainFileId: sharedStepProps.initialValues.passport_main_file_id,
    initialPassportRegistrationFileId: sharedStepProps.initialValues.passport_registration_file_id,
    initialDocumentAgreement1FileId: sharedStepProps.initialValues.document_agreement1_file_id,
    initialDocumentAgreement2FileId: sharedStepProps.initialValues.document_agreement2_file_id,
    initialDocumentPricesTariffsFileId: sharedStepProps.initialValues.prices_tariffs_file_id,
    urlHelperFile: HELPER_FILE,
    textLinkAttachment
  });

  return (
    <V2Wizard
      {...sharedStepProps}
      logoFileId={attachmentsDetails.logoFileId}
      passportMainFileId={attachmentsDetails.passportMainFileId}
      passportRegistrationFileId={attachmentsDetails.passportRegistrationFileId}
      documentAgreement1FileId={attachmentsDetails.documentAgreement1FileId}
      setDocumentAgreement1FileIdRequiredError={setDocumentAgreement1FileIdRequiredError}
      documentAgreement2FileId={attachmentsDetails.documentAgreement2FileId}
      handleRequestAttachmentsDetails={attachmentsDetails.handleRequestAttachmentsDetails}
      isLoadingAttachmentsDetails={attachmentsDetails.isLoadingAttachmentsDetails}
      isErrorAttachmentsDetails={attachmentsDetails.isErrorAttachmentsDetails}
      pricesTariffsLinkError={attachmentsDetails.pricesTariffsLinkError}
      isRequiredOffer={true}
      isWorkWithThirdParties={isWorkWithThirdParties}
    >
      <DefaultPage />
      <AccountDetails
        clientId={clientId}
        orgType={OrgTypeEnum.Company}
        isShowAdditionalFieldsInitially={!!sharedStepProps.initialValues[NamesOfFieldEnum.LprName]}
      />
      <CompanyDetails clientId={clientId} />
      <PayformTechDetails
        clientId={clientId}
        {...attachmentsDetails}
        COUNT_UPLOAD_LOGO_FILE={COUNT_UPLOAD_LOGO_FILE}
        paymentMethod={paymentMethod}
        educationalPlatform={educationalPlatform}
        productType={productType}
        typeRequestCheckPayformName={sharedStepProps.typeRequestCheckPayformName}
        setTypeRequestCheckPayformName={sharedStepProps.setTypeRequestCheckPayformName}
        callbackCheckPayformName={sharedStepProps.callbackCheckPayformName}
        errorMsgCheckPayformName={sharedStepProps.errorMsgCheckPayformName}
        isFirstRenderPayformTechDetailsStep={isFirstRenderPayformTechDetailsStep}
        setIsFirstRenderPayformTechDetailsStep={setIsFirstRenderPayformTechDetailsStep}
        setIsLogoProcessing={sharedStepProps.setIsLogoProcessing}
      />
      <AdditionalDetails queryPromocode={queryPromocode} />
      <AttachmentsDetails
        {...attachmentsDetails}
        clientId={clientId}
        COUNT_UPLOAD_LOGO_FILE={COUNT_UPLOAD_LOGO_FILE}
        orgType={OrgTypeEnum.Company}
        textLinkAttachment={textLinkAttachment}
        setTextLinkAttachment={setTextLinkAttachment}
        isUploadOffer={sharedStepProps.isUploadOffer}
        setIsUploadOffer={sharedStepProps.setIsUploadOffer}
        errorUploadOffer={sharedStepProps.errorUploadOffer}
        setErrorUploadOffer={sharedStepProps.setErrorUploadOffer}
        offer={sharedStepProps.offer}
        textLinkOffer={sharedStepProps.textLinkOffer}
        setTextLinkOffer={sharedStepProps.setTextLinkOffer}
        isGeneratedOffer={sharedStepProps.isGeneratedOffer}
        setIsGeneratedOffer={sharedStepProps.setIsGeneratedOffer}
        documentAgreement1FileIdRequiredError={documentAgreement1FileIdRequiredError}
        workType={workType}
        setWorkType={setWorkType}
        isWorkWithThirdParties={isWorkWithThirdParties}
      />
    </V2Wizard>
  );
};
